import React, {useState} from 'react'

import 'asset/style/thresholder.css'
import {post} from 'helper/request'
import {Button, Col, Divider, message, Progress, Row} from "antd";
import {openEndPoint} from "../utils/utils";
import {error_manager} from "../helper/error_manager";

const Thresholder = () => {
    const [value, setValue] = useState('')

    const [completed, setCompleted] = useState([])
    const [inProgress, setInProgress] = useState([])

    const progressTracker = (filepaths) => {
        const url = "/api/threshold/status/";
        post(url, {filepaths})
            .then(res => {
                let {data} = res;

                var inP = [];
                for (const [key, value] of Object.entries(data)) {
                    inP.push(
                        <div>
                            <Col span={15}>
                                <div style={{fontSize: '15px'}}>
                                    {key}
                                </div>
                            </Col>
                            <Col span={7}>
                                <Progress percent={value * 100}/>
                            </Col>
                        </div>
                    );
                }
                setInProgress(curr => inP);

                if (data.all) {
                    setCompleted(curr => true);
                } else {
                    setCompleted(curr => false);
                }

                let timerId = setTimeout(
                    () => progressTracker(filepaths),
                    2000
                );
                if (data.all) {
                    message.success("Data Prep Success");
                    clearTimeout(timerId);
                }
            })
            .catch(err => {
                error_manager("Cannot Get Thresh Progress. Contact Admin.", err)
            });
    };


    const handleScanProcess = (value) => {
        if (!value) return

        const filepaths = value
            .split(',')
            .filter(e => !!e)
            .map(e => e.trim().replace('"', '')) || []

        post('/api/threshold/prepare_scan/', {filepaths})
            .then(() => {
                setCompleted(curr => "Preparation Ongoing");
                setInProgress(curr => [...filepaths])
                progressTracker(filepaths);
                message.success("Started Data Prep");
            })
    }

    const handlePreviewProcess=(value) => {
        if (!value) return

        const filepaths = value
            .split(',')
            .filter(e => !!e)
            .map(e => e.trim().replace('"', '')) || []

        post('/api/threshold/prepare_preview/', {filepaths})
            .then((response) => {
                if (response.success > 0){
                    message.success("Preview Data Prep Completed Successfully");
                }
                if (response.fail > 0){
                    message.warn(`${response.fail} Preview Data Prep Failed. Please Check the input Paths`)
                }
            })
    }

    const handleScanDataDelete = () => {
        post('/api/threshold/delete_scan/')
            .then(() => {
                message.success("Scan Data Reset Successful");
            })
    }

    const handlePreviewDataDelete = () => {
        post('/api/threshold/delete_preview/')
            .then(() => {
                message.success("Preview Data Reset Successful");
            })
    }

    const goToThreshUI = (e) => {
        openEndPoint("/main_thresh/1", false, true);
    }

    return (
        <div id="scanner-div">
            <Row className="rounded-container">
                <Col className="scanner-name arial-font" span={24}>
                    {"High Power Thresholding Data Generator"}
                </Col>
            </Row>
            <Row>
                <Col offset={1} span={12}>
                    <textarea
                        cols={'20'}
                        rows={'20'}
                        value={value}
                        onChange={(e) => setValue(e.target.value)}
                        className="input"
                        placeholder={'Enter image path here after copying from dashboard'}
                    />
                    <Button onClick={() => handleScanProcess(value)}>Process Scan</Button>
                    <Button onClick={() => handlePreviewProcess(value)}>Process Preview</Button>
                    <Button onClick={() => handleScanDataDelete()}>Reset Scan Data</Button>
                    <Button onClick={() => handlePreviewDataDelete()}>Reset Preview Data</Button>
                    <Divider/>
                    <Row>
                        {inProgress}
                    </Row>
                    <Divider/>
                </Col>
                <Col span={10}>
                    <Row>
                        <Col offset={10} span={6}>
                            <Button type="primary" onClick={goToThreshUI}>
                                Go To Thresholding UI
                            </Button>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </div>
    )
}

export default Thresholder